import { useRoutes } from 'react-router-dom'

import routes from './routes'

export default function App() {
  // This is the main entry point for the backoffice application.
  return useRoutes(routes)
}
